import { Layers } from '../libs/layers/layers.ts';

const layersStack = new Layers(window);

window.layers = layersStack;

export default layersStack;
